import React from 'react';
import PropTypes from 'prop-types';

import FixedTooltipPortal from 'dpl/common/tooltip/components/FixedTooltipPortal';
import useAnalyticsContext from 'dpl/puppy_search_results/hooks/useAnalyticsContext';

export default function ExposedLocationFilterBottomModal({
  isFilterMenuOpen,
  setIsFilterMenuOpen,
  title,
  children
}) {
  const { sendBreedSearchedAnalytics } = useAnalyticsContext();

  function handleCloseClick() {
    setIsFilterMenuOpen(false);
    sendBreedSearchedAnalytics();
  }

  return (
    <FixedTooltipPortal
      isVisible={isFilterMenuOpen}
      onCloseClick={handleCloseClick}
    >
      <p className="font-20 font-serif fw-medium bb b--default pt3 pb5 mb6">
        {title}
      </p>
      {children}
    </FixedTooltipPortal>
  );
}

ExposedLocationFilterBottomModal.propTypes = {
  isFilterMenuOpen: PropTypes.bool.isRequired,
  setIsFilterMenuOpen: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
